<!-- =====================================================================
     LEGACY VIEWER — src[] / fileData[] inputs (unchanged)
     Hidden when blobItems is provided so the two modes never conflict.
     ===================================================================== -->
@if (!blobItems || !blobItems.length) {
  @if (dialogConfig && fileData && fileData[index].contentType=='application/pdf') {
    <pdf-viewer [config]="{'document_name':fileData[index].name, 'url': url}" [isBlob]="false"></pdf-viewer>
  }
  @if (dialogConfig && fileData && fileData[index].contentType=='application/dicom') {
    <diacom-viewer [config]="{url:url, documentId:dialogConfig.data.documentId}"></diacom-viewer>
  } @else {
    @if (!dataDefined) {
      <div [ngxToggleFullscreen]="fullscreen" class="img-container"
        [style.backgroundColor]="config.containerBackgroundColor" (wheel)="scrollZoom($event)"
        (dragover)="onDragOver($event)">
        <!-- {{src | json}} -->
        <img [attr.src]="src[index] | secure  | async " #imageRef [ngStyle]="style" (dragstart)="onDragStart($event)"
          (load)="onLoad()" (loadstart)="onLoadStart()" />
        <!-- Div below will be used to hide the 'ghost' image when dragging -->
        <div></div>
        @if (loading) {
          <div class="spinner-container">
            <div class="spinner"></div>
          </div>
        }
        <!-------------------------To Show When Image not Found---------------------------->
        @if (loading) {
          <div class="no-record-found">
            <div class="no-record-found-img-container">
              <img src="assets/images/nodata-icon.svg" class="no-records-found"/>
              <div class="no-records-found-text">
                <span >{{'field.label.no_records_found' | translate | async}}</span>
              </div>
            </div>
          </div>
        }
        @if (config.btnShow.rotateCounterClockwise) {
          <button type="button" [class]="config.btnClass"
            (click)="rotateCounterClockwise()">
            <span [class]="config.btnIcons.rotateCounterClockwise"></span>
          </button>
        }
        @if (config.btnShow.rotateClockwise) {
          <button type="button" [class]="config.btnClass" (click)="rotateClockwise()">
            <span [class]="config.btnIcons.rotateClockwise"></span>
          </button>
        }
        @if (config.btnShow.zoomOut) {
          <button type="button" [class]="config.btnClass" (click)="zoomOut()">
            <span [class]="config.btnIcons.zoomOut"></span>
          </button>
        }
        @if (config.btnShow.zoomIn) {
          <button type="button" [class]="config.btnClass" (click)="zoomIn()">
            <span [class]="config.btnIcons.zoomIn"></span>
          </button>
        }
        @for (cBtn of config.customBtns; track cBtn) {
          <button type="button" [class]="config.btnClass"
            (click)="fireCustomEvent(cBtn.name, index)">
            <span [class]="cBtn.icon"></span>
          </button>
        }
        @if (config.allowFullscreen) {
          <button type="button" id="ngx-fs-btn" [class]="config.btnClass" (click)="toggleFullscreen()"
            >
            <span [class]="config.btnIcons.fullscreen"></span>
          </button>
        }
        @if (config.allowDownload && !rolePermissionService.checkAccessPermission('download_disabled')) {
          <button type="button" [class]="config.btnClass"
            (click)="downloadFile(fileData[index])">
            <span [class]="config.btnIcons.download"></span>
          </button>
        }
        @if (src.length > 1) {
          <div class="nav-button-container">
            <button type="button" [class]="config.btnClass" (click)="prevImage()" [disabled]="index === 0">
              <span [class]="config.btnIcons.prev"></span>
            </button>
            <button type="button" [class]="config.btnClass" (click)="nextImage()" [disabled]="index === src.length - 1">
              <span [class]="config.btnIcons.next"></span>
            </button>
          </div>
        }
      </div>
    }
  }
}
<!-- =====================================================================
     END LEGACY VIEWER
     ===================================================================== -->


<!-- =====================================================================
     NEW: BLOB ITEMS VIEWER — blobItems[] input
     Each item carries its own {url, type, name}. Supports: image, pdf,
     dicom, audio, video. All new code is contained in this block only.
     ===================================================================== -->
@if (blobItems && blobItems.length > 0) {
  <div class="blob-viewer-container">

    @switch (activeBlobItem.type) {

      <!-- PDF ---------------------------------------------------------- -->
      @case ('pdf') {
        <div class="blob-viewer-pane">
          <pdf-viewer
            [config]="{'document_name': activeBlobItem.name || 'document', 'blob': activeBlobItem.url}"
            [isBlob]="true">
          </pdf-viewer>
        </div>
      }

      <!-- DICOM -------------------------------------------------------- -->
      @case ('dicom') {
        <div class="blob-viewer-pane">
          <diacom-viewer [config]="{url: activeBlobItem.url}"></diacom-viewer>
        </div>
      }

      <!-- Image -------------------------------------------------------- -->
      @case ('image') {
        <div class="img-container blob-viewer-pane"
          [style.backgroundColor]="config.containerBackgroundColor"
          (wheel)="scrollZoom($event)"
          (dragover)="onDragOver($event)">
          <img [src]="activeBlobItem.url" [ngStyle]="style"
            (dragstart)="onDragStart($event)"
            (load)="onLoad()" (loadstart)="onLoadStart()" />
          <div></div>
          @if (loading) {
            <div class="spinner-container"><div class="spinner"></div></div>
          }
          @if (config.btnShow.rotateCounterClockwise) {
            <button type="button" [class]="config.btnClass" (click)="rotateCounterClockwise()">
              <span [class]="config.btnIcons.rotateCounterClockwise"></span>
            </button>
          }
          @if (config.btnShow.rotateClockwise) {
            <button type="button" [class]="config.btnClass" (click)="rotateClockwise()">
              <span [class]="config.btnIcons.rotateClockwise"></span>
            </button>
          }
          @if (config.btnShow.zoomOut) {
            <button type="button" [class]="config.btnClass" (click)="zoomOut()">
              <span [class]="config.btnIcons.zoomOut"></span>
            </button>
          }
          @if (config.btnShow.zoomIn) {
            <button type="button" [class]="config.btnClass" (click)="zoomIn()">
              <span [class]="config.btnIcons.zoomIn"></span>
            </button>
          }
          @if (config.allowFullscreen) {
            <button type="button" id="ngx-fs-btn" [class]="config.btnClass" (click)="toggleFullscreen()">
              <span [class]="config.btnIcons.fullscreen"></span>
            </button>
          }
          @if (config.allowDownload && !rolePermissionService.checkAccessPermission('download_disabled')) {
            <a [href]="activeBlobItem.url" [download]="activeBlobItem.name || 'image'"
               class="blob-download-btn" [class]="config.btnClass">
              <span [class]="config.btnIcons.download"></span>
            </a>
          }
        </div>
      }

      <!-- Audio -------------------------------------------------------- -->
      @case ('audio') {
        <div class="blob-media-container">
          @if (activeBlobItem.name) {
            <div class="blob-media-label">{{ activeBlobItem.name }}</div>
          }
          <audio controls class="blob-audio-player">
            <source [src]="activeBlobItem.url" />
            Your browser does not support the audio element.
          </audio>
        </div>
      }

      <!-- Video -------------------------------------------------------- -->
      @case ('video') {
        <div class="blob-media-container">
          @if (activeBlobItem.name) {
            <div class="blob-media-label">{{ activeBlobItem.name }}</div>
          }
          <video controls class="blob-video-player">
            <source [src]="activeBlobItem.url" />
            Your browser does not support the video element.
          </video>
        </div>
      }

    }

    <!-- Navigation — only when there are multiple items --------------- -->
    @if (blobItems.length > 1) {
      <div class="blob-nav-container">
        <button type="button" [class]="config.btnClass"
          (click)="prevBlobItem()" [disabled]="blobIndex === 0">
          <span [class]="config.btnIcons.prev"></span>
        </button>
        <span class="blob-nav-counter">{{ blobIndex + 1 }} / {{ blobItems.length }}</span>
        <button type="button" [class]="config.btnClass"
          (click)="nextBlobItem()" [disabled]="blobIndex === blobItems.length - 1">
          <span [class]="config.btnIcons.next"></span>
        </button>
      </div>
    }

  </div>
}
<!-- =====================================================================
     END NEW: BLOB ITEMS VIEWER
     ===================================================================== -->
